var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
/**
 * # Spacer
 *
 * 공백 및 크기를 쉽게 나타낼 수 있는 컴포넌트입니다.
 *
 * @param {SpacerProps} {@link SpacerProps} 기본적인 Spacer Props
 *
 * @example ```tsx
 * <Container>
      <Container>
        <Container style={{ background: Colors.PRIMARY.FOREGROUND }}>
          <Spacer />
        </Container>
        <Container style={{ background: Colors.PRIMARY.FOREGROUND }}>
          <Spacer y={2} />
        </Container>
        <Container style={{ background: Colors.PRIMARY.FOREGROUND }}>
          <Spacer y={3} />
        </Container>
      </Container>
      <Container row>
        <Container style={{ background: Colors.PRIMARY.FOREGROUND }} />
        <Spacer x={3} y={3} />
        <Container style={{ background: Colors.PRIMARY.FOREGROUND }} />
      </Container>
    </Container>
 * ```
 */
export var Spacer = function (props) {
    var _a = props.x, x = _a === void 0 ? 1 : _a, _b = props.y, y = _b === void 0 ? 1 : _b;
    return <Space x={x} y={y}/>;
};
var Space = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  width: 1px;\n  height: 1px;\n  min-width: 1px;\n  min-height: 1px;\n"], ["\n  ", "\n\n  width: 1px;\n  height: 1px;\n  min-width: 1px;\n  min-height: 1px;\n"])), function (_a) {
    var x = _a.x, y = _a.y;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: calc(", "rem - 1px);\n    margin-top: calc(", "rem - 1px);\n  "], ["\n    margin-left: calc(", "rem - 1px);\n    margin-top: calc(", "rem - 1px);\n  "])), 1.5 * x, 1.5 * y);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.jsx.map